export function validatePassword(password) {
  const errors = [];
  const conditions = {
    upperCase: /[A-Z]/.test(password),
    lowerCase: /[a-z]/.test(password),
    number: /\d/.test(password),
    specialChar: /[!@#$%^&*()_+=[\]{};':"\\|,./?-]/.test(password),
  };

  const angleBracketError = /[<>]/.test(password);

  // if < or > exists exit early and return error
  if (angleBracketError) {
    return { pass: false, error: 'Password cannot contain < or >.' };
  }

  // If less than 8 chars, exit early and return error
  if (password.length < 8) {
    errors.push('Password must be at least 8 characters.');
    return { pass: false, error: errors.join(' ') };
  }

  if (!conditions.upperCase) {
    errors.push('an uppercase letter');
  }
  if (!conditions.lowerCase) {
    errors.push('a lowercase letter');
  }
  if (!conditions.number) {
    errors.push('a number');
  }
  if (!conditions.specialChar) {
    errors.push('a special character');
  }

  // If all conditions are met, return true for pass and null for error
  const pass =
    password.length >= 8 &&
    Object.values(conditions).filter(Boolean).length === 4;

  const error = pass ? null : `Password must include: ${errors.join(', ')}.`;

  return { pass, error };
}
